import { render, staticRenderFns } from "./GovernmentDeductionSchedule.vue?vue&type=template&id=7efe616a"
import script from "./GovernmentDeductionSchedule.vue?vue&type=script&lang=js"
export * from "./GovernmentDeductionSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports